import { render, staticRenderFns } from "./EcoBw.vue?vue&type=template&id=5e1ececc&"
import script from "./EcoBw.vue?vue&type=script&lang=js&"
export * from "./EcoBw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports